import React from "react";

interface Props {
  changeCategory?: string;
}

/**
 * Badge indicating the category of a change record.
 *
 * Category is descriptive, not a severity, so all three variants use the
 * neutral family with the label carrying the meaning. The previous
 * blue/purple/indigo scheme read as a severity ranking that does not exist,
 * and none of those hues survive a dark background legibly.
 */
const LABELS: Record<string, string> = {
  connection: "Connection",
  schedule: "Schedule",
  report: "Report",
};

export default function ChangeCategoryBadge({ changeCategory }: Props) {
  // Legacy records predate this field and are reports.
  const label = LABELS[changeCategory ?? ""] ?? "Report";

  return (
    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-neutral-subtle text-neutral-fg border border-neutral-border">
      {label}
    </span>
  );
}
